<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 4a20 20 0 1020 20A20 20 0 0024 4zm0 37a17 17 0 1117-17 17 17 0 01-17 17z"/><path d="M31.57 16.46a1.51 1.51 0 00-2.12 0L24 21.89l-5.45-5.44a1.5 1.5 0 10-2.12 2.12L21.9 24l-5.44 5.43a1.51 1.51 0 000 2.12 1.53 1.53 0 001.06.44 1.49 1.49 0 001.06-.44L24 26.14l5.41 5.41a1.51 1.51 0 001.06.44 1.5 1.5 0 001.06-2.56L26.14 24l5.43-5.44a1.51 1.51 0 000-2.1z"/></svg>